import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import breakpoints from 'static/script/utils/breakpoints';
import isTouch from 'static/script/utils/is-touch';
import userPreferences from 'static/script/app/data/user-preferences';

function SiteHeader() {

    let myTraderaLinksToggleTimer;

    this.LANDING_PAGENAMES_FROM_ADVANCED_SEARCH = [
        'Category', // Browse
        'SearchResults' // Search
    ];

    this.defaultAttrs({
        cartNotificationsItemsSelector: '[data-site-header-cart-notifications-items]',
        cartNotificationsSelector: '[data-site-header-cart-notifications]',
        searchLinkSelector: '[data-search-link]',
        hamburgerLinkSelector: '[data-header-hamburger]',
        myTraderaLinksToggle: '[data-site-header-menu-toggle]',
        myTraderaLinks: '[data-site-header-menu-links]',
        myTraderaLinksContainer: '[data-site-header-menu-container]',
        advancedSearchLinkSelector: '[data-site-header-advanced-search-link]',
        myTraderaLink: '[data-my-tradera-link]',
        initData: null
    });

    this._populateNotifications = function (evt, payload) {
        if (payload.totalCount > 0) {
            this._showNotifications(payload.totalCount);
        } else {
            this._hideNotificaitons();
        }
    };

    this._showNotifications = function (nr) {
        let notifications = this.select('cartNotificationsSelector'),
            itemsCounter = this.select('cartNotificationsItemsSelector');

        itemsCounter.html(nr);

        if (notifications.prop('hidden')) {
            notifications.removeProp('hidden');
        }
    };

    this._hideNotificaitons = function () {
        let notifications = this.select('cartNotificationsSelector'),
            itemsCounter = this.select('cartNotificationsItemsSelector');

        itemsCounter.html('');

        if (!notifications.prop('hidden')) {
            notifications.prop('hidden', true);
        }
    };

    this._searchIconClick = function () {
        this.trigger(document, 'ui:site-header:on-search-click');
    };

    this._hamburgerClicked = function () {
        this.trigger(document, 'ui:site-header:on-hamburger-click');
        this.trigger(document, 'analytics:track-event', {
            category: 'Header',
            action: 'Navigation',
            label: 'Side menu - show'
        });
    };

    this._toggleMyTraderaLinks = function (evt) {
        if (isTouch() && breakpoints.isVisible(breakpoints.siteheaderportrait)) {
            evt.preventDefault();
            evt.stopPropagation();

            this.select('myTraderaLinks').toggle();

            if (this.select('myTraderaLinks').is(':visible')) {
                this.trigger(document, 'ui:site-header-my-tradera-dropdown-on-show');
            } else {
                this.select('myTraderaLinksToggle').blur();
            }
        }
    };

    this._hideMyTraderaLinks = function () {
        clearTimeout(myTraderaLinksToggleTimer);
        this.select('myTraderaLinks').hide();
        this.select('myTraderaLinksToggle').blur();
    };

    this._showMyTraderaLinks = function () {
        if (!isTouch() && breakpoints.isVisible(breakpoints.siteheaderportrait)) {
            myTraderaLinksToggleTimer = setTimeout(function () {
                this.select('myTraderaLinks').show();
            }.bind(this), 200);
        }
    };

    this._onTeardown = function () {
        // Remove non-flight bindings
        this.select('myTraderaLinksContainer').off('mouseenter');
        this.select('myTraderaLinksContainer').off('mouseleave');
    };

    this._updateAdvancedSearchUrl = function () {
        let link = this.select('advancedSearchLinkSelector'),
            path = this._includeLeadingForwardSlash(link[0].pathname),
            newUrl = path;

        if (this.LANDING_PAGENAMES_FROM_ADVANCED_SEARCH.indexOf(this.attr.initData.pageName) >= 0) {
            newUrl = this.attr.initData.advancedSearchUrl || path + window.location.search;
        }

        let fromPageText = (this.attr.initData.pageName ? ' - from: ' + this.attr.initData.pageName : '');
        link.attr('data-ga-category', 'Header');
        link.attr('data-ga-action', 'Navigation');
        link.attr('data-ga-label', 'Advanced search' + fromPageText);
        link.attr('href', newUrl);
    };

    // Some older versions of IE does not include a leading forward slash in pathname
    this._includeLeadingForwardSlash = function (str) {
        if (str.charAt(0) === '/') {
            return str;
        }

        return '/' + str;
    };

    this._updateMyTraderaLink = function () {
        let lastOpenTab = userPreferences.get('MyTraderaLastOpenTab');
        if (lastOpenTab && lastOpenTab.indexOf('/my/') === 0) {
            this.select('myTraderaLink').attr('href', lastOpenTab);
        }
    };

    this.after('initialize', function () {
        this._updateAdvancedSearchUrl();

        this.on('click', {
            searchLinkSelector: this._searchIconClick,
            hamburgerLinkSelector: this._hamburgerClicked,
            myTraderaLinksToggle: this._toggleMyTraderaLinks
        });

        this.on(document, 'data:navigation:after-page-load', this._updateMyTraderaLink);
        this.on(document, 'ui:mega-categories-on-show', this._hideMyTraderaLinks);
        this.on(document, 'ui:navigation:after-page-change', this._hideMyTraderaLinks);

        this.select('myTraderaLinksContainer').on('mouseenter', this._showMyTraderaLinks.bind(this));
        this.select('myTraderaLinksContainer').on('mouseleave', this._hideMyTraderaLinks.bind(this));

        this.on(document, 'data:cart:after-get-summary', this._populateNotifications);
        this.on(document, 'ui:teardown', this._onTeardown);
    });
}

module.exports = defineComponent.component(SiteHeader);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/site-header.js